import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledUserItem = styled(Grid)<{
  $isActive: boolean,
}>(({
  theme,
  $isActive
}) => ({
  alignItems: "center",
  background: $isActive ? "#FFFFFF1A" : undefined,
  borderRadius: $isActive ? theme.spacing(1) : undefined,
  borderBottom: $isActive ? "none" : `1px solid ${theme.customColors.border}`,
  color: theme.customColors.textPrimary,
  display: "flex",
  justifyContent: "space-between",
  padding: "8px",
  width: "100%",
  maxWidth: "348px",
  "img": {
    borderRadius: "50%"
  },

  "p": {
    fontWeight: $isActive ? 500 : undefined
  }
}));
